import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Drawer,
  FormControlLabel,
  InputBase,
  Radio,
  RadioGroup,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import DashboardHeader from "@components/Header/DashboardHeader";
import {
  getDashboardListing,
  getDashboardEditThunk,
  getFilterApplicationThunk,
  getDashboardDeleteThunk,
} from "./redux/thunk/dashboardThunk";
import EnhancedTable from "@components/Table/TableView";
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import type { AppDispatch, RootState } from "@store/store";
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { fetchApplicationDetails } from "@modules/application-section/application-details/redux/services/thunk/DetailsThunk";
import { setAmenityField } from "@modules/stepper/redux/amenitesSlice";
import { setSiteRoadwaysField } from "@modules/stepper/redux/siteRoadwaysSlice";
import { setActiveStep } from "@modules/stepper/redux/stepperSlice";
import { resetSiteRoadWaysState } from "@modules/stepper/redux/siteRoadwaysSlice";
import { resetAmenityState } from "@modules/stepper/redux/amenitesSlice";
import { resetAmenityROWState } from "@modules/stepper-row/redux/amenitesROWSlice";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import dayjs from "dayjs";
import { setAmenityROWField } from "@modules/stepper-row/redux/amenitesROWSlice";
import {
  resetSiteRoadwaysROW,
  setSiteRoadwaysROWField,
} from "@modules/stepper-row/redux/siteRoadwaysROWSlice";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import ApplicationFilter from "./filter/ApplicationFilter";
import { fetchApplicationROWDetails } from "@modules/application-section-row/application-details-row/redux/services/thunk/DetailsThunk";
import NoData from "@assets/svg/no-data.svg";
import CloseIcon from "@mui/icons-material/Close";
import ProvisionalLicense from "@modules/application-section-row/commonModal/ProvisionalLicenseModal";
import FinalLicenseModal from "@modules/application-section-row/commonModal/FinalLicenseModal";
import { setApplicationType } from "@modules/mainDashboard/src/redux/slices/dashboardSlice";
import RequestFinalLicence from "@modules/application-section-row/commonModal/RequestFinalLicenceModal";
import FinalNOCModal from "@components/Modal/FinalNOCModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { resetApplicationSubmitted } from "../application-details/redux/applicationSubmittedSlice";
import {
  fetchApplicationDetailsRow,
  getTransactionStatusThunk,
} from "@modules/provisional-payment/redux/thunk/application-detailThunk";
import { toast } from "react-toastify";
import ConfirmDialog from "@components/Modal/ConfirmModal";
// import SearchApplication from "./searchApplication";
import LegacyDrawer from "./legacyDrawer";
import DeclarationModal from "./DeclarationModal";

const tabOptions = [
  { label: "All" },
  { label: "Access Applications" },
  { label: "Right Of Way Applications" },
];

export const ApplicationDashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const [count, setCount] = React.useState(0);
  const [applications, setApplications] = React.useState<any[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = React.useState<any>(null);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [isPaymentOpen, setIsPaymentOpen] = React.useState(false);
  const [isFinalPaymentOpen, setIsFinalPaymentOpen] = React.useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // NEW
  const [debouncedSearchTerm, setDebouncedSearchTerm] =
    React.useState(searchTerm);
  // const [runActionAfterSet, setRunActionAfterSet] = useState("");
  const { sort, sortBy } = useSelector((state: any) => state.uiData);
  const [openModal, setOpenModal] = React.useState(false);

  // Add these new state variables
  const [declarationModalOpen, setDeclarationModalOpen] = React.useState(false);
  const [pendingAction, setPendingAction] = React.useState<
    "new" | "migrate" | null
  >(null);

  const [filterPayload, setFilterPayload] = React.useState<
    Record<string, any> | undefined
  >(undefined);
  const [filterCount, setFilterCount] = React.useState<number>(0);
  const [filterData, setFilterData] = React.useState<any>({});
  const breadcrumbData = [{ label: "", link: "#" }];
  const [isUploadMediaOpen, setIsUploadMediaOpen] = React.useState(false);
  const [isRequestExtensionOpen, setIsRequestExtensionOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const menuCloseTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [legacyDrawer, setLegacyDrawer] = useState(false);
  const handleMenuClose = () => {
    setAnchorEl(null);
    if (menuCloseTimeoutRef.current) {
      clearTimeout(menuCloseTimeoutRef.current);
    }
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
    event.stopPropagation();
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const fetchTransactionStatus = async (
    application_id: any,
    category: string,
  ) => {
    try {
      const res = await dispatch(
        getTransactionStatusThunk(application_id),
      ).unwrap();
      if (res?.status) {
        navigate(
          "/esign?" +
          (category == "row"
            ? `row=${application_id}`
            : `access=${application_id}`),
        );
      } else {
        navigate(
          "/payment?" +
          (category == "row"
            ? `row=${application_id}`
            : `access=${application_id}`),
        );
      }
    } catch (error) {
      console.error("Error fetching transaction status:", error);
    }
  };

  const { applicationDetails, loading, error } = useSelector(
    (state: RootState) => state.applicationDetails,
  );

  const { applicationDetailsROW } = useSelector(
    (state: RootState) => state.applicationDetailsROW,
  );

  const applicationDetailsData = applicationDetails || applicationDetailsROW;
  const applicantName = applicationDetailsData?.created_by_uname || "";
  const amenityName = applicationDetailsData?.property_type || "";
  const area = applicationDetailsData?.location_type_name || "";
  const locationAddress = applicationDetailsData?.address_1 || "";
  // const status_id = applicationDetailsData?.status_id || "";

  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  const handleView = async () => {
    if (!selectedRow) return;

    let getApplicationDetails;

    if (selectedRow.category === "Access") {
      getApplicationDetails = await dispatch(
        fetchApplicationDetails(selectedRow.id),
      );
      dispatch(setApplicationType(1));
    } else if (selectedRow.category === "ROW") {
      getApplicationDetails = await dispatch(
        fetchApplicationROWDetails(selectedRow.id),
      );
      dispatch(setApplicationType(2));
    }
    if (getApplicationDetails?.meta?.requestStatus === "fulfilled") {
      if (selectedRow.category === "Access") {
        dispatch(setAmenityField({ name: "access_id", value: selectedRow.id }));
        navigate(`/application-details`);
      } else if (selectedRow.category === "ROW") {
        dispatch(
          setAmenityROWField({ name: "access_id", value: selectedRow.id }),
        );
        navigate(`/application-details-row`);
      }
    }
  };

  const handleDelete = async () => {
    if (!selectedRow) return;
    try {
      const result = await dispatch(
        getDashboardDeleteThunk({
          access_id: selectedRow.id,
        }),
      );
      if (result?.payload?.success) {
        toast.success(result?.payload?.message);
      } else {
        toast.error("Something went Wrong. Try again!");
      }
    } catch (error) {
      toast.error("Something went Wrong. Try again!");
    }
  };

  const handleDeleteClick = () => {
    setOpenConfirm(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await handleDelete();
      fetchDashboardData();
    } catch (error) {
      // console.error("Delete failed:", error);
    } finally {
      setOpenConfirm(false);
    }
  };

  const handleEdit = async () => {
    if (!selectedRow) return;

    // 🔁 Reset all states
    dispatch(resetSiteRoadWaysState());
    dispatch(resetAmenityState());
    dispatch(resetSiteRoadwaysROW());
    dispatch(resetAmenityROWState());

    let selectedCatId = 0;
    if (selectedRow.category === "Access") selectedCatId = 1;
    else if (selectedRow.category === "ROW") selectedCatId = 2;
    if (!selectedCatId) return;

    // 🔹 Fetch edit payload
    const result = await dispatch(
      getDashboardEditThunk({
        access_id: selectedRow.id,
        application_categroy_id: selectedCatId,
      }),
    );

    if (result?.meta?.requestStatus !== "fulfilled") return;

    const applicationData: any = result?.payload?.data || {};

    // 🔹 Helper: boolean → Yes / No
    const booleanToYesNo = (value: boolean | null | undefined) => {
      if (value === true) return "Yes";
      if (value === false) return "No";
      return "";
    };

    // 🔹 Helper: prevent overwriting with empty values
    const safeDispatch = (action: any, name: string, value: any) => {
      if (value !== null && value !== undefined && value !== "") {
        dispatch(action({ name, value }));
      }
    };

    /* =====================================================
     ================= ACCESS APPLICATION ================
     ===================================================== */
    if (selectedCatId === 1) {
      // 🔹 Set access id
      safeDispatch(setAmenityField, "access_id", applicationData?.id);

      /**
       * Fields that must be stored as "Yes" / "No" strings (radio fields),
       * even though the API may return them as booleans (true / false).
       */
      const booleanToYesNoFields = [
        "is_service_road_provided",
        "is_constructed_without_prior_permission",
        "is_facility_operational",
        "is_facility_operational_consent",
        "is_part_of_rest_area",
        "on_slip_road",
        // "area_acquired",
        "access_criteria_met",
        "is_located_on_service_road",
        "meets_general_access_requirements",
        "is_coco_fuel_station",              // ✅ added
        "fuel_station_carriageway_type",     // ✅ added
      ];

      // 🔥 Keys that must NOT be blindly copied (recomputed below)
      const SKIP_KEYS = new Set([
        "questions",
        "question_true",
        "question_false",
        "questionList",
        "selectedQuestions",
      ]);

      // 🔹 Single pass: normalize booleans → "Yes"/"No" once, dispatch to BOTH slices
      Object.entries(applicationData).forEach(([name, value]) => {
        if (SKIP_KEYS.has(name)) return;

        const normalizedValue = booleanToYesNoFields.includes(name)
          ? booleanToYesNo(value as boolean)
          : value;

        safeDispatch(setAmenityField, name, normalizedValue);
        safeDispatch(setSiteRoadwaysField, name, normalizedValue);
      });

      /**
       * 🔥 Fallback: if API doesn't send `is_coco_fuel_station` at all,
       * default it to "No" so LOI fields become visible.
       */
      const cocoValue = applicationData?.is_coco_fuel_station;
      if (cocoValue === undefined || cocoValue === null || cocoValue === "") {
        safeDispatch(setSiteRoadwaysField, "is_coco_fuel_station", "No");
        safeDispatch(setAmenityField, "is_coco_fuel_station", "No");
      }

      /**
       * 🔥 Fallback: if API doesn't send `fuel_station_carriageway_type`,
       * still dispatch it explicitly so the select doesn't hold a stale value.
       */
      const carriagewayValue = applicationData?.fuel_station_carriageway_type;
      if (
        carriagewayValue !== undefined &&
        carriagewayValue !== null &&
        carriagewayValue !== ""
      ) {
        const normalizedCarriageway = booleanToYesNoFields.includes(
          "fuel_station_carriageway_type",
        )
          ? booleanToYesNo(carriagewayValue as boolean)
          : carriagewayValue;

        safeDispatch(setSiteRoadwaysField, "fuel_station_carriageway_type", normalizedCarriageway);
        safeDispatch(setAmenityField, "fuel_station_carriageway_type", normalizedCarriageway);
      }

      /* =========================================================
         🔥 CRITICAL FIX
         Dispatch numeric IDs to BOTH slices.
         ========================================================= */
      safeDispatch(setSiteRoadwaysField, "property_type_id", applicationData?.property_type_id);
      safeDispatch(setSiteRoadwaysField, "location_type_id", applicationData?.location_type_id);
      safeDispatch(setSiteRoadwaysField, "service_road_type_id", applicationData?.service_road_type_id);

      safeDispatch(setAmenityField, "property_type_id", applicationData?.property_type_id);
      safeDispatch(setAmenityField, "location_type_id", applicationData?.location_type_id);
      safeDispatch(setAmenityField, "service_road_type_id", applicationData?.service_road_type_id);
      safeDispatch(setAmenityField, "category_id", applicationData?.category_id);

      // "Others" property type text — only when property_type_id === 6
      if (Number(applicationData?.property_type_id) === 6) {
        safeDispatch(
          setSiteRoadwaysField,
          "othersPropertyType",
          applicationData?.othersPropertyType,
        );
      }

      /* ---------- QUESTIONS → RADIO MAPPING (must run LAST) ---------- */
      const questionTrue: number[] = [];
      const questionFalse: number[] = [];

      applicationData?.questions?.forEach((q: any) => {
        if (!q?.question_id) return;

        const val = String(q.value); // normalize to string
        if (val === "Yes") questionTrue.push(q.question_id);
        if (val === "No") questionFalse.push(q.question_id);

        safeDispatch(setSiteRoadwaysField, String(q.question_id), val);
      });

      // 🔥 Raw dispatch — bypass safeDispatch's empty-string guard so an
      // empty array still clears stale values.
      dispatch(setSiteRoadwaysField({ name: "question_true", value: questionTrue }));
      dispatch(setSiteRoadwaysField({ name: "question_false", value: questionFalse }));

      safeDispatch(setSiteRoadwaysField, "is_previously_approved", false);

      dispatch(setActiveStep(applicationData?.form_step || 0));
      dispatch(resetApplicationSubmitted());
      navigate("/stepper");
    }

    /* =====================================================
     ================= ROW APPLICATION ===================
     ===================================================== */
    if (selectedCatId === 2) {
      safeDispatch(setAmenityROWField, "application_id", applicationData?.id);
      safeDispatch(
        setSiteRoadwaysROWField,
        "application_id",
        applicationData?.id,
      );

      safeDispatch(setAmenityROWField, "access_id", applicationData?.id);

      // 🔹 propertyType === 13 → othersPropertyType
      if (Number(applicationData?.property_type_id) === 13) {
        safeDispatch(
          setSiteRoadwaysROWField,
          "othersPropertyType",
          applicationData?.othersPropertyType,
        );
      }

      // 🔹 service_road_type_id === 1 → nested flags
      if (Number(applicationData?.service_road_type_id) === 1) {
        safeDispatch(
          setSiteRoadwaysROWField,
          "is_located_on_service_road",
          booleanToYesNo(applicationData?.is_located_on_service_road),
        );
        safeDispatch(
          setSiteRoadwaysROWField,
          "meets_general_access_requirements",
          booleanToYesNo(applicationData?.meets_general_access_requirements),
        );
      }

      const yesIds: number[] = [];
      const noIds: number[] = [];
      const fieldValues: Record<string, any> = {};

      applicationData?.questions?.forEach((q: any) => {
        // Convert value to boolean
        const val = String(q.value).toLowerCase();

        if (val === "yes") {
          yesIds.push(q.question_id);
        } else if (val === "no") {
          noIds.push(q.question_id);
        }
      });

      // 🔹 Save base fields
      Object.entries(applicationData).forEach(([name, value]) => {
        safeDispatch(setAmenityROWField, name, value);
      });

      // 🔹 Save input fields
      Object.entries(applicationData).forEach(([name, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          safeDispatch(setSiteRoadwaysROWField, name, String(value));
        }
      });

      // 🔹 Save radio arrays
      safeDispatch(setSiteRoadwaysROWField, "questions_true", yesIds);
      safeDispatch(setSiteRoadwaysROWField, "questions_false", noIds);

      dispatch(setActiveStep(applicationData?.form_step || 0));
      dispatch(resetApplicationSubmitted());
      navigate("/stepper-row");
    }
  };

  const handleFinalNOCAccess = (obj: any, e: React.MouseEvent<HTMLElement>) => {
    setSelectedRow(obj); // ✅ Set entire object, not just obj.id
    handleMenuClose();

    // Open drawer after menu has had time to close
    menuCloseTimeoutRef.current = setTimeout(() => {
      setIsRequestExtensionOpen(true);
    }, 150);
  };

  const handleDrawerClose = () => {
    setIsRequestExtensionOpen(false);
    // Clear timeout when drawer closes
    if (menuCloseTimeoutRef.current) {
      clearTimeout(menuCloseTimeoutRef.current);
    }
  };

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      if (menuCloseTimeoutRef.current) {
        clearTimeout(menuCloseTimeoutRef.current);
      }
    };
  }, []);

  // Update the New Application button click handler
  const handleNewApplication = () => {
    setPendingAction("new");
    setDeclarationModalOpen(true);
  };

  // Update the Migrate/Import button click handler
  const handleMigrateApplication = () => {
    setPendingAction("migrate");
    setDeclarationModalOpen(true);
  };

  // Handle declaration proceed
  const handleDeclarationProceed = () => {
    setDeclarationModalOpen(false);
    if (pendingAction === "new") {
      navigate("/dashboard");
    } else if (pendingAction === "migrate") {
      setLegacyDrawer(true);
    }
    setPendingAction(null);
  };

  // Handle declaration close
  const handleDeclarationClose = () => {
    setDeclarationModalOpen(false);
    setPendingAction(null);
  };

  const renderStatusBadge = (status: string) => {
    const statusStyles: Record<string, { text: string; bg: string }> = {
      "Inspection Pending": { text: "#9F7803", bg: "#FFF3CD" },
      "Visit Scheduled": { text: "#0471A2", bg: "#D4F0FD" },
      "Report Submitted": { text: "#4CAF50", bg: "#DBEFDC" },
      "Recommended to CA": { text: "#2196F3", bg: "#D3EAFD" },
      "Application Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "Final Application Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "Renewal Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "Payment Pending": { text: "#B86D00", bg: "#FFEACC" },
      "Payment Received": { text: "#43A047", bg: "#D9ECDA" },
      "Forwarded to Competent Authority": { text: "#1976D2", bg: "#D1E4F6" },
      "Provisional NOC Issued": { text: "#6FA135", bg: "#E2ECD7" },
      "EOT Requested": { text: "#AB47BC", bg: "#EEDAF2" },
      "EOT Approved": { text: "#6A1B9A", bg: "#E1D1EB" },
      "EOT Rejected": { text: "#E53935", bg: "#FAD7D7" },
      "Clarification Requested": { text: "#FF7043", bg: "#FFE2D9" },
      "Clarification Updated": { text: "#26A69A", bg: "#D4EDEB" },
      "Final NOC Issued": { text: "#2E7D32", bg: "#D5E5D6" },
      "Application Submitted, Under Review with Proposing Authority": {
        text: "#154321",
        bg: "#AEDCBA",
      },
      Draft: { text: "#757575", bg: "#ECECEC" },
      "Scrutiny Pending": { text: "#9F7803", bg: "#FFF3CD" },
      "Payment Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "BG Forfeiture Initiated": { text: "#B3261D", bg: "#F0D4D2" },
      "Renewal NOC Issued": { text: "#2E7D32", bg: "#D5E5D6" },
      "Renewal Requested": { text: "#9F7803", bg: "#FFF3CD" },
    };

    const style = statusStyles[status] || { bg: "#f3f4f6", color: "#374151" };

    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          px: 1.5,
          py: 0.5,
          borderRadius: "3px",
          fontSize: "0.875rem",
          fontWeight: 500,
          bgcolor: style.bg,
          color: style.text,
        }}
      >
        <Box
          component="span"
          sx={{
            display: "inline-block",
            width: 4,
            height: 4,
            borderRadius: "50%",
            bgcolor: style.text,
          }}
        ></Box>
        {status}
      </Box>
    );
  };

  // for stage badge
  const renderStageBadge = (stage: string) => {
    const styles: Record<string, { bg: string; color: string }> = {
      Draft: { bg: "transparent", color: "#7A7A7A" },
      Approved: { bg: "transparent", color: "#154321" },
      "In Transit": { bg: "#4682B433", color: "#4682B4" },
      Payment: { bg: "transparent", color: "#009688" }, // Teal
    };

    const style = styles[stage] || { bg: "transparent", color: "#374151" };

    return (
      <Box
        sx={{
          display: "inline-flex",

          borderRadius: "3px",
          fontSize: "0.875rem",
          fontWeight: 500,
          bgcolor: style.bg,
          color: style.color,
        }}
      >
        <Box component="span"></Box>
        {stage}
      </Box>
    );
  };

  const rowsWithAction = applications.map((obj) => ({
    ...obj,
    updated_at: obj.updated_at
      ? dayjs(obj.updated_at).format("DD/MM/YYYY")
      : "",
    stage: renderStageBadge(obj.stage),
    status_name: renderStatusBadge(
      obj.clk_req_applicant ? "Clarification Requested" : obj.status_name,
    ),
    property_name: (
      <Typography
        noWrap
        title={obj.property_name}
        sx={{
          maxWidth: 100,
          display: "inline-block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          cursor: "pointer",
        }}
      >
        {obj.property_name?.split(" ").slice(0, 20).join(" ")}
        {obj.property_name?.split(" ").length > 20 ? "..." : ""}
      </Typography>
    ),
    action: (
      <>
        <IconButton
          onClick={(e) => handleMenuOpen(e, obj)}
          aria-controls="action-menu"
          aria-haspopup="true"
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="action-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl && selectedRow?.id === obj.id)}
          onClose={handleMenuClose}
          // Add transition properties for smoother close
          TransitionProps={{ timeout: 150 }}
        >
          {obj.status_id !== 1 && (
            <MenuItem
              sx={{ minWidth: "10rem" }}
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClose();
                handleView();
              }}
            >
              View
            </MenuItem>
          )}

          {obj.status_id === 6 ? (
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClose();
                if (selectedRow.category == "Access") {
                  fetchTransactionStatus(obj?.id, "access");
                } else if (selectedRow.category == "ROW") {
                  fetchTransactionStatus(obj?.id, "row");
                }
              }}
            >
              Pay Provisional NOC Fee
            </MenuItem>
          ) : obj.status_id === 35 ? (
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                if (obj.category == "Access") {
                  navigate(`/final-license-fee?access=${selectedRow?.id}`);
                } else if (obj.category == "ROW") {
                  navigate(`/final-license-fee?row=${selectedRow?.id}`);
                }
              }}
            >
              Pay Final NOC Fee
            </MenuItem>
          ) : null}

          {obj.status_id === 8 &&
            obj.category === "Access" &&
            new Date(obj.created_at) >= oneYearAgo && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleFinalNOCAccess(obj, e);
                }}
              >
                Apply for Final NOC
              </MenuItem>
            )}
          {obj.status_id === 14 && (
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                if (obj.category == "Access") {
                  navigate(
                    `/apply-renewal?access=${selectedRow?.id}&category=${selectedRow?.amenity_utility_name}`,
                  );
                } else if (obj.category == "ROW") {
                  navigate(
                    `/apply-renewal?row=${selectedRow?.id}&category=${selectedRow?.amenity_utility_name}`,
                  );
                }
              }}
            >
              Apply for Renewal
            </MenuItem>
          )}

          {obj.status_id === 8 && obj.category === "ROW" && (
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClose();
                setTimeout(() => {
                  setIsUploadMediaOpen(true);
                }, 150);
              }}
            >
              Apply for Final NOC
            </MenuItem>
          )}
          {obj.status_id === 76 && obj.category === "ROW" && (
            <MenuItem
              onClick={() => {
                navigate("/esign?row=" + obj?.id);
              }}
            >
              Proceed to E-Sign
            </MenuItem>
          )}

          {obj.status_id === 1 && (
            <>
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleMenuClose();
                  handleEdit();
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleMenuClose();
                  handleDeleteClick();
                }}
              >
                Delete
              </MenuItem>
            </>
          )}
        </Menu>
      </>
    ),
  }));

  // These should be properly defined in your actual code
  const headCells = [
    { key: "application_code", label: "Application ID", sort: true },
    { key: "property_name", label: "Application Name", sort: true },
    { key: "updated_at", label: "Application Date", sort: true },
    { key: "highway_no", label: "Highway No.", sort: true },
    { key: "stage", label: "Stage", sort: true },
    { key: "status_name", label: "Status", sort: true },
    { key: "action", label: "Action", sort: false },
  ];
  const selectedColumns = headCells.map((col) => col.key);
  const rows = applications;

  const handleChangeTablePage = (newPage: number) => {
    setPage(newPage);
  };

  const fromDate = filterPayload?.from
    ? dayjs(filterPayload.from).format("YYYY-MM-DD")
    : "";
  const toDate = filterPayload?.to
    ? dayjs(filterPayload.to).format("YYYY-MM-DD")
    : "";

  const fetchDashboardData = async () => {
    const payload = {
      page: page,
      limit: 7,
      stage: filterPayload?.stage || [],
      property_type_id: filterPayload?.access_categories_id || [],
      amenity_id: filterPayload?.row_categories_id || [],
      application_category: activeTab,
      created_at:
        fromDate || toDate ? { from: fromDate, to: toDate } : undefined,
      searchTerm: debouncedSearchTerm.trim(),
      sort_by: sortBy,
      sort_order: sort,
    };
    try {
      const response = await dispatch(getDashboardListing(payload));
      if (response?.meta?.requestStatus === "fulfilled") {
        setApplications(response.payload?.data || []);
      }
      const totalCount = response?.payload?.pagination?.total || 0;
      setCount(totalCount);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  React.useEffect(() => {
    fetchDashboardData();
  }, [
    debouncedSearchTerm,
    activeTab,
    page,
    sort,
    sortBy,
    filterPayload,
    isRequestExtensionOpen,
    isUploadMediaOpen,
  ]);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  React.useEffect(() => {
    const fetchFilterData = async () => {
      const resultAction = await dispatch(getFilterApplicationThunk());
      if (
        resultAction?.meta?.requestStatus === "fulfilled" ||
        resultAction?.payload?.data
      ) {
        // Ensure filterData is always an array
        const data = resultAction?.payload?.data;
        // const filterArray = Array.isArray(data) ? data : (data?.stage || []);
        setFilterData(data);
      }
    };
    fetchFilterData();
  }, [openModal]);

  const handleChangeTableSort = () => {
    // Add sorting logic if
  };

  return (
    <>
      <DeclarationModal
        open={declarationModalOpen}
        onClose={handleDeclarationClose}
        onProceed={handleDeclarationProceed}
        title={
          pendingAction === "new"
            ? "New Application"
            : "Import / Migrate Application"
        }
      />
      {/* Request Extension Dialog */}
      <RequestFinalLicence
        isRequestFinalLicenceOpen={isUploadMediaOpen}
        setIsRequestFinalLicenceOpen={setIsUploadMediaOpen}
        applicationId={selectedRow?.id}
        onSuccess={() => dispatch(fetchApplicationROWDetails(selectedRow?.id))}
      />
      <FinalNOCModal
        openSlider={isRequestExtensionOpen}
        setOpenSlider={handleDrawerClose}
        applicationId={selectedRow?.id}
        onSuccess={() => dispatch(fetchApplicationDetails(selectedRow?.id))}
      />
      {applicationDetailsData && (
        <ProvisionalLicense
          applicationDetails={applicationDetailsData}
          isPaymentOpen={isPaymentOpen}
          setIsPaymentOpen={setIsPaymentOpen}
          applicationId={selectedRow?.id}
          applicantName={applicantName}
          amenityName={amenityName}
          area={area}
          locationAddress={locationAddress}
        />
      )}
      {applicationDetailsData && (
        <FinalLicenseModal
          applicationDetails={applicationDetailsData}
          isFinalPaymentOpen={isFinalPaymentOpen}
          setIsFinalPaymentOpen={setIsFinalPaymentOpen}
          applicationId={selectedRow?.id}
          applicantName={applicantName}
          amenityName={amenityName}
          area={area}
          locationAddress={locationAddress}
        />
      )}

      {/* Payment Processing Dialog */}
      <Dialog
        open={isProcessing}
        onClose={() => setIsProcessing(false)}
        maxWidth="xs"
      >
        <DialogTitle className="dialog-title">
          Payment Gateway
          <IconButton
            aria-label="close"
            onClick={() => setIsProcessing(false)}
            className="close-icon"
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          className="dialog-content"
          sx={{ textAlign: "center" }}
        >
          <Box className="dot-loader" />
          <Typography variant="subtitle2" className="popup-body">
            Payment Processing
          </Typography>
          <Typography variant="body2" className="dialog-description">
            You will be redirected to the Bharat Kosh portal to finalize your
            payment. Please do not close the page or press the back button till
            the transaction is complete.
          </Typography>
        </DialogContent>
      </Dialog>
      <LegacyDrawer dialogOpen={legacyDrawer} setDialogOpen={setLegacyDrawer} />

      <Box className="app-details-wrapper">
        <div className="page-content">
          {/* <DashboardHeader /> */}
          <>
            <Box
              className="application-banner-header mb-3"
              sx={{ gap: { xs: 2, sm: 0 } }}
            >
              <Typography className="application-id">Dashboard</Typography>
              <Box className="banner-buttons">
                <Button
                  onClick={handleMigrateApplication}
                  variant="outlined"
                  className="btnContinue-outline"
                  sx={{
                    width: "fit-content",
                    marginLeft: { xs: 0, sm: 2 },
                  }}
                >
                  Migrate / Import Existing Application
                </Button>
                <Button
                  variant="contained"
                  onClick={handleNewApplication}
                  className="btnContinue"
                  sx={{
                    width: "180px",
                    marginLeft: { xs: 0, sm: 1 },
                  }}
                >
                  <AddOutlinedIcon
                    className="dropdown-icon"
                    style={{ color: "#fff" }}
                  />
                  New Application
                </Button>
              </Box>
            </Box>
            <div className="w-full bg-gray-000 rounded-lg p-4">
              <Box className="application-banner-wrapper">
                <Box className="application-banner"></Box>
              </Box>

              <Box className="card-header">
                <Box
                  display="flex"
                  borderRadius={1}
                  overflow="hidden"
                  border="1px solid #dee1e6"
                  width="fit-content"
                >
                  {tabOptions?.map((tab, idx) => (
                    <Button
                      key={tab.label}
                      onClick={() => setActiveTab(idx)}
                      variant={activeTab === idx ? "contained" : "text"}
                      sx={{
                        bgcolor: activeTab === idx ? "#F4F6FA" : "white",
                        color: "#222",
                        borderRadius: 0,
                        borderRight:
                          idx === tabOptions?.length - 1
                            ? "none"
                            : "1px solid #dee1e6",
                        boxShadow: "none",
                        fontWeight: 400,
                        width: "fit-content",
                        minWidth: "unset",
                        paddingInline: "1rem",
                        "&:hover": {
                          bgcolor: "#F4F6FA",
                        },
                      }}
                    >
                      {tab.label}
                    </Button>
                  ))}
                </Box>
                <Box className="search-filter-wrapper">
                  <Box className="search-bar">
                    <InputBase
                      placeholder="Search"
                      className="search-input"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setPage(1);
                      }}
                    />
                    <SearchIcon className="search-icon" />
                  </Box>
                  <Box onClick={handleOpenModal} className="filter-button">
                    Filter
                    <KeyboardArrowDownOutlinedIcon />
                  </Box>
                </Box>
              </Box>

              <ApplicationFilter
                open={openModal}
                handleClose={handleCloseModal}
                handleSubmit={(filters) => {
                  setFilterPayload(filters);
                  setOpenModal(false);
                  setPage(1); // Optionally reset page
                }}
                filterData={filterData}
                initialFilters={filterPayload}
              />
              {applications.length == 0 ? (
                <Box
                  sx={{
                    minHeight: "65vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <img
                    src={NoData}
                    alt="No Applications"
                    style={{ width: 320, marginBottom: 32 }}
                  />
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      textAlign: "center",
                      fontSize: "16px",
                      color: "#212121",
                    }}
                  >
                    No records available.
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#757575",
                      maxWidth: 500,
                      mb: 4,
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    There are currently no applications to display.Please click
                    on “New Application” button to proceed.
                  </Typography>
                  {/* <Box className="banner-buttons">
                    <Button
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      className="btnContinue"
                      sx={{
                        width: "180px"
                      }}
                    >
                      <AddOutlinedIcon
                        className="dropdown-icon"
                        style={{ color: "#fff" }}
                      />
                      New Application
                    </Button>
                  </Box> */}
                </Box>
              ) : (
                <EnhancedTable
                  tableColumns={headCells.filter((obj) =>
                    selectedColumns.includes(obj.key),
                  )}
                  tablerows={rowsWithAction.map((obj) =>
                    Object.fromEntries(
                      Object.entries(obj).filter(([key]) =>
                        selectedColumns.includes(key),
                      ),
                    ),
                  )}
                  handleChangeTablePage={handleChangeTablePage}
                  handleChangeTableSort={handleChangeTableSort}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  count={count}
                />
              )}
            </div>
          </>
        </div>
      </Box>
      <ConfirmDialog
        open={openConfirm}
        message={`Are you sure you want to delete ${selectedRow?.application_code} application?`}
        title="Confirm Validation"
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={handleConfirmDelete}
        onClose={() => setOpenConfirm(false)}
      />
    </>
  );
};
